import axios from 'axios';
import { getContentProvider } from '@/helper/auth';

// eslint-disable-next-line import/prefer-default-export
export const fetchRecordingChannels = () => {
    const { key } = getContentProvider();

    return axios.get(`/cms/${key}/select_channels?keyword=&kind=programming`);
};

export const fetchSchedule = (programId) => {
    const { key } = getContentProvider();

    return axios.get(`/cms/${key}/program-schedules/${programId}`);
};

export const fetchSchedules = (params = null) => {
    const { key } = getContentProvider();

    return axios.get(`/cms/${key}/programs/schedules`, { params });
};

export const createSchedule = (channelId, form) => {
    const { key } = getContentProvider();

    return axios.post(`/cms/${key}/channels/${channelId}/programs`, form);
};

export const updateSchedule = (channelId, programId, form) => {
    const { key } = getContentProvider();

    return axios.put(`/cms/${key}/channels/${channelId}/programs/${programId}`, form);
};

export const removeSchedule = (liveMediaChannelId, programId) => {
    const { key } = getContentProvider();

    return axios.delete(`/cms/${key}/channels/${liveMediaChannelId}/programs/${programId}`);
};
